"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRound = useRound;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useRound() {
    const rounds = (0, stores_1.useCalculatorStore)((state) => state.data.rounds);
    const now = (0, stores_1.useCalculatorStore)((state) => state.now);
    return (0, react_1.useMemo)(() => (rounds ? (0, view_models_1.currentRound)(rounds, now ? new Date(now) : new Date()) : undefined), [rounds, now]);
}
